import React from 'react';
import {IProduct} from 'data/interfaces/products';
import AdDateBetween from '../adDateBetween/AdDateBetween';
import AdRoomSize from '../adRoomSize/AdRoomSize';
import AdStreet from '../adStreet/AdStreet';
import VacationInfoSquare from '../vacationInfoSquare/VacationInfoSquare';
import FlightInfoSquare
  from 'gui/components/listPage/components/ad/components/flightInfoSquare';
import AdCardStructureContainer from 'data/redux/containers/adCardStructureContainer';
import AdRoomsAmount
  from 'gui/components/listPage/components/ad/components/adRoomsAmount';

interface IAdProps {
  product: IProduct;

  view?: (id: number) => void
  edit?: (id: number) => void
  delete?: (id: number) => void
}

export const generateCountryNameFromProduct = (product: Partial<IProduct>, selectLang = 'HE') => {
  if (product.continentDetails && product.continentDetails.translations && Array.isArray(product.continentDetails.translations)) {
    const hebrewCountry = product.continentDetails.translations.find(({lang}) => lang === selectLang);
    if (hebrewCountry) {
      return hebrewCountry.country_name;
    }
  }
  return ["-", product.hotelDetails.hotel.country].join("");
};

export const generateAdVacationTitle = (props: Partial<{ product: Partial<IProduct> }>) => {
  return ['חבילת נופש ל', generateCountryNameFromProduct(props.product)].join("");
};

export const AdVacationCardDetails = props => <>
  <AdDateBetween
    startDate={props.product.ticketDetails.originTimeOfTakeOff}
    endDate={props.product.ticketDetails.destinationTimeOfLanding}
  />
  <AdRoomSize
    people={props.product.hotelDetails.roomPeopleAmount}
  />
  <AdRoomsAmount
    roomsAmount={props.product.hotelDetails.roomsAmount}
  />
  <AdStreet placeDetails={props.product.placeDetails}/>
</>;

const AdVacation = (props: IAdProps) => (
  <AdCardStructureContainer
    displaySquare={VacationInfoSquare}
    cardTitle={generateAdVacationTitle(props)}
    specialDetails={<AdVacationCardDetails {...props}/>}
    specialDetails2={
      <FlightInfoSquare style={{backgroundColor: "transperent", height: "initial"}} showIcon={false}
                        product={props.product}/>
    }
    timeRemaining={props.product.hotelDetails.checkInDate}
    salePriceLabel="מחיר לכל הכרטיסים"
    originalPrice={Math.floor(props.product.ticketDetails.currentAirlineAllTicketsPrice)}
    salePrice={Math.floor(props.product.saleDetails.askingPrice)}
    {...props}
  />
);

AdVacation.defaultProps = {
  product: {},

  hideControl: false,
  hideStatus: false,

  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },
};
export default AdVacation;
